export default __webpack_public_path__ + "static/media/Baltimore Life Dark.c5b89fc7.svg";